import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedMaterialModule } from 'src/app/shared/shared-material.module';
import { TemplateLibraryModule } from '../case-details/template-library/template-library.module';
import { CaseDetailTableComponent } from './case-detail-table/case-detail-table.component';
import { CommonGridComponent } from './common-grid/common-grid.component';
import { ConfirmStaffRoleDeletionComponent } from './confirm-staff-role-deletion/confirm-staff-role-deletion.component';
import { CustomDynamicFormComponent } from './custom-dynamic-form/custom-dynamic-form.component';
import { ElipsisComponent } from './elipsis/elipsis.component';
import { GenericSearchComponent } from './generic-search/generic-search.component';
import { ModifySystemicDialogComponent } from './modify-systemic-dialog/modify-systemic-dialog.component';
import { SearchAssociatedChargesComponent } from './search-associated-charges/search-associated-charges.component';
import { SearchResultCaseDetailComponent } from './search-result-case-detail/search-result-case-detail.component';
import { SearchResultTableComponent } from './search-result-table/search-result-table.component';
import { SharedActivityLogComponent } from './shared-activity-log/shared-activity-log.component';
import { SharedAllegationSelectionComponent } from './shared-allegation-selection/shared-allegation-selection.component';
import { SharedOriginatingAllegationSelectionComponent } from './shared-originating-allegation-selection/shared-originating-allegation-selection.component';
import { SharedEditCpComponent } from './shared-edit-cp/shared-edit-cp.component';
import { NotesDialogComponent } from './notes-dialog/notes-dialog.component';
import { SharedEditDefendantComponent } from './shared-edit-defendant/shared-edit-defendant.component';
import { SharedEditIndividualComponent } from './shared-edit-individual/shared-edit-individual.component';
import { SharedEditRespondentComponent } from './shared-edit-respondent/shared-edit-respondent.component';
import { SharedEditSystemicCaseComponent } from './shared-edit-systemic-case/shared-edit-systemic-case.component';
import { SharedEditSystemicSearchCasesComponent } from './shared-edit-systemic-search-cases/shared-edit-systemic-search-cases.component';
import { SharedLinkEmlTableComponent } from './shared-link-eml-table/shared-link-eml-table.component';
import { SharedNaicsLookupDialogComponent } from './shared-naics-lookup-dialog/shared-naics-lookup-dialog.component';
import { SharedSystemicSearchCasesTableComponent } from './shared-systemic-search-cases-table/shared-systemic-search-cases-table.component';
import { SharedViewActivityLogComponent } from './shared-view-activity-log/shared-view-activity-log.component';
import { SharedViewCpComponent } from './shared-view-cp/shared-view-cp.component';
import { SharedViewPartiesComponent } from './shared-view-parties/shared-view-parties.component';
import { SharedViewRespondentComponent } from './shared-view-respondent/shared-view-respondent.component';
import { SharedViewWitnessComparatorExpandableComponent } from './shared-view-witness-comparator-expandable/shared-view-witness-comparator-expandable.component';
import { SystemicDashboardComponent } from './systemic-dashboard/systemic-dashboard.component';
import { SystemicDetailComponent } from './systemic-detail/systemic-detail.component';
import { SharedEditComplainantComponent } from './shared-edit-complainant/shared-edit-complainant.component';
import { SharedViewAgencyComponent } from './shared-view-complainant/shared-view-agency.component';
import { SharedEditAgencyComponent } from './shared-edit-agency/shared-edit-agency.component';
import { SearchComplainantComponent } from './search-complainant/search-complainant.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { HearingSearchEffects } from '../dashboard/store/effects/hearings-search.effects';
import { HEARING_SEARCH_FEATURE_KEY, searchReducer } from '../dashboard/store/reducers/hearings-search.reducer';
import { HrsAdditionalPartiesComponent } from './hrs-additional-parties/hrs-additional-parties.component';
import { HrsAdditionalPartiesViewComponent } from './hrs-additional-parties-view/hrs-additional-parties-view.component';
import { SharedClaimsListComponent } from './shared-claims-list/shared-claims-list.component';
import { SearchPartyComponent } from '../new-inquiry/search-party/search-party.component';

@NgModule({
    declarations: [
        SharedEditRespondentComponent,
        SharedViewRespondentComponent,
        SharedEditCpComponent,
        NotesDialogComponent,
        SharedViewCpComponent,
        SearchResultTableComponent,
        SearchResultCaseDetailComponent,
        SharedLinkEmlTableComponent,
        CaseDetailTableComponent,
        SharedViewWitnessComparatorExpandableComponent,
        SharedViewActivityLogComponent,
        SharedNaicsLookupDialogComponent,
        SharedAllegationSelectionComponent,
        SharedOriginatingAllegationSelectionComponent,
        SharedEditSystemicCaseComponent,
        ElipsisComponent,
        SharedEditSystemicSearchCasesComponent,
        SharedSystemicSearchCasesTableComponent,
        SystemicDashboardComponent,
        SystemicDetailComponent,
        ModifySystemicDialogComponent,
        SharedActivityLogComponent,
        CustomDynamicFormComponent,
        SearchAssociatedChargesComponent,
        ConfirmStaffRoleDeletionComponent,
        SharedEditIndividualComponent,
        SharedEditDefendantComponent,
        SharedViewPartiesComponent,
        CommonGridComponent,
        GenericSearchComponent,
        SharedEditComplainantComponent,
        SharedViewAgencyComponent,
        SharedEditAgencyComponent,
        SearchComplainantComponent,
        HrsAdditionalPartiesComponent,
        HrsAdditionalPartiesViewComponent,
        SharedClaimsListComponent,
        SearchPartyComponent
    ],
    imports: [CommonModule, SharedMaterialModule, FormsModule, ReactiveFormsModule, TemplateLibraryModule,
        StoreModule.forFeature(HEARING_SEARCH_FEATURE_KEY, searchReducer),
        EffectsModule.forFeature([HearingSearchEffects]),],
    exports: [
        CommonGridComponent,
        SharedEditRespondentComponent,
        SharedViewRespondentComponent,
        SharedViewPartiesComponent,
        SharedEditCpComponent,
        SharedViewCpComponent,
        NotesDialogComponent,
        CaseDetailTableComponent,
        SharedViewWitnessComparatorExpandableComponent,
        SharedViewActivityLogComponent,
        SharedNaicsLookupDialogComponent,
        SharedAllegationSelectionComponent,
        SharedOriginatingAllegationSelectionComponent,
        SharedEditSystemicCaseComponent,
        SystemicDashboardComponent,
        SystemicDetailComponent,
        ElipsisComponent,
        SharedActivityLogComponent,
        CustomDynamicFormComponent,
        GenericSearchComponent,
SharedEditComplainantComponent,
        SharedViewAgencyComponent,
        HrsAdditionalPartiesViewComponent,
        SearchComplainantComponent,
        SharedClaimsListComponent,
        SearchPartyComponent
    ]
})
export class SharedEditFormsModule {}
